<template>
  <Container
      :options="{ width: 3840, height: 1675 }"
      style="padding-bottom: 30px"
  >
    <jtHeader></jtHeader>
    <div class="content">
      <div class="top-container">
        <div class="item">
          <RailWayData
              :list="railWayData"
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
          ></RailWayData>
        </div>

        <div class="item">
          <StorageGoods
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
              v-if="isStorageGoods"
              :tbWarehousingGoodsL="tbWarehousingGoodsL"
          ></StorageGoods>
          <!-- <StorageGoods></StorageGoods> -->
        </div>
        <div class="item">
          <ContainerGoods
              class="animate-left"
              :class="{ 'animate-left-hide': hide }"
              v-if="isContainerGoods"
              :tbContainerYards="tbContainerYards"
          ></ContainerGoods>
        </div>
      </div>
      <div class="top-container2">
        <!-- 累计 -->
        <div
            class="item3 count-item count animate-top"
            :class="{ 'animate-top-hide': hide }"
        >
          <Count :monthCarTS="monthCarTS" :monthFee="monthFee" :monthCarTA="monthCarTA"></Count>
        </div>

        <!-- //箱区管理 -->
        <div
            class="boxArea animate-bottom"
            :class="{ 'animate-bottom-hide': hide }"
        >
          <BoxArea :list="xqglList"></BoxArea>
        </div>

        <!-- 在途预报 -->
        <div class="inTransit">
          <!-- <SwiperData
            class="swiperData animate-bottom"
            :dataList="tbForecastOnWays"
            title="在途预报"
           v-if="isSwiperData" 
          ></SwiperData> -->
          <SwiperData class="swiperData animate-bottom" :tbForecastOnWaysXC="tbForecastOnWaysXC"
                      :dataList="tbForecastOnWays" :class="{ 'animate-bottom-hide': hide }"></SwiperData>
        </div>
      </div>

      <div class="top-container3">
        <!-- 车辆进出情况 -->
        <div class="item">
          <!-- <CarCount
          class="animate-right"
         
          
         :tbVehicleAccessList="tbVehicleAccessList">
        </CarCount> -->
          <CarCount class="animate-right" v-if="isCarCount" :class="{ 'animate-right-hide': hide }"
                    :tbVehicleAccessList="tbVehicleAccessList"></CarCount>
        </div>

        <!-- 集装箱办理量 -->
        <div class="item">
          <!-- <ContainerHandler
          class="animate-right"
          :class="{ 'animate-right-hide': hide }"
          v-if="isContainerHandler"
          :tbContainerHandlingVolumeList="tbContainerHandlingVolumeList"
        ></ContainerHandler> -->
          <ContainerHandler v-if="isContainerHandler" class="animate-right"
                            :tbContainerHandlingVolumeList="tbContainerHandlingVolumeList"
                            :class="{ 'animate-right-hide': hide }"></ContainerHandler>
        </div>

        <div class="item">
          <!-- <Notice
          class="animate-right"
          :class="{ 'animate-right-hide': hide }"
          :list="tbGeneralSituation"
        ></Notice> -->
          <Notice class="animate-right" :class="{ 'animate-right-hide': hide }" v-if="isNotice"
                  :tbWarehousingGoods="tbWarehousingGoods"></Notice>
        </div>
      </div>
    </div>
  </Container>
</template>
<script>
// import { getDatas } from '@/api/api'
import Container from "@/components/Container";
import jtHeader from "@/components/Header";
import RailWayData from "./components/RailwayData";
import StorageGoods from "./components/StorageGoods";
import ContainerGoods from "./components/ContainerGoods";
import ContainerHandler from "./components/ContainerHandler";
import CarCount from "./components/CarCount";
import SwiperData from "./components/SwiperData";
import Count from "./components/Count";
import Notice from "./components/Notice";
import axios from "axios";
import BoxArea from "./components/BoxArea";

export default {
  components: {
    Container,
    jtHeader,
    RailWayData,
    StorageGoods,
    ContainerGoods,
    SwiperData,
    Count,
    Notice,
    CarCount,
    ContainerHandler,
    BoxArea,
  },
  data() {
    return {
      hide: false,
      hidebottom: true,
      isStorageGoods: false,
      isContainerGoods: false,
      isCarCount: false,
      isContainerHandler: false,
      isNotice: false,
      isSwiperData: false,
      fullscreen: false,
      monthCarTS: 0,
      monthCarTA: 0,//累计出入车数、计费车数、费用累计数
      monthFee: 0,
      railWayData: {
        sentCarYesterday: '',
        unloadCarYesterday: '',
        monthCarS: '',
        monthCarA: '',
        sentTYesterday: '',
        unloadTonnesYesterday: ''
      }, //铁路
      xqglList: [],//想去管理
      //今日运单量
      tbWarehousingGoods: {
        // documentDate: [],
        // warehousingInToday: [],
        // warehousingOutToday: [],
        // warehousingBalanceToday: [],
      },
      //仓储货物到发
      tbWarehousingGoodsL: {
        documentDate: [],
        warehousingInToday: [],
        warehousingOutToday: [],
        warehousingBalanceToday: [],
      },
      //集装箱堆场到发情况
      tbContainerYards: {
        documentDate: [],
        containerInoutTodayWeight: [], //今日进
        containerInoutTodayAir: [], //今日出
        containerBalanceTodayAir: [], //今天结存
      },
      //集装箱堆场到发情况  车辆进出
      tbVehicleAccessList: {
        documentDate: [],
        inToday: [], //今日进
        outToday: [], //今日出
      },
      //车辆进出情况
      tbContainerHandlingVolumeList: {
        //isContainerHandler
        documentDate: [],
        arrived: [], //日到达
        send: [], //日发送
      },
      tbForecastOnWays: [],
      tbForecastOnWaysXC: [],
      // header:,
      tbCarDistributions: [],
      tbGeneralSituation: [],
    };
  },
  methods: {
    handleFullscreen() {
      this.fullscreen = !this.fullscreen;
    },
    handleChange() {
      this.handleFullscreen();
    },

    handlerRailWayData(data) {
      let _this = this;

      function _handler(_data, title, index, color) {
        _this.railWayData.push({
          imgUrl: require(`@/assets/images/icon_${index}.png`),
          title: title,
          num: _data ? parseInt(_data) : 0,
          color: color,
        });
      }

      for (let val in data) {
        if (val == "sentCarYesterday") {
          _handler(data[val], "日发送车", 1, "#2df9cc");
        }
        if (val == "unloadCarYesterday") {
          _handler(data[val], "日到达车", 2, "#EFFF72");
        }
        if (val == "monthCarS") {
          _handler(data[val], "累计发送车", 3, "#FA9931");
        }
        if (val == "monthCarA") {
          _handler(data[val], "累计到达车", 4, "#FA9931");
        }
        if (val == "sentTYesterday") {
          _handler(data[val], "日发送吨", 5, "#34DAFA");
        }
        if (val == "unloadTonnesYesterday") {
          _handler(data[val], "日到达吨", 6, "#29F8E9");
        }
      }
    },
    getData() {
      axios({
        method: "get",
        url: "api/screen/statistics/bigScreenData",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json;charset=utf-8",
        },
        //url: "http://diaodu.lywly.com.cn/prod-api/home/screen",
        // url: "http://150.139.212.142:19091/home/screen",
      }).then((res) => {

        this.xqglList = res.data.data.boxAreaManages
        this.carNumSumFees = res.data.data.carNumSumFees
        this.carNumSumFees.forEach(ele => {
          if (ele.name == "累计出入车数") {
            this.monthCarTS = parseInt(ele.value);
          } else if (ele.name == "计费车辆数") {
            this.monthFee = parseInt(ele.value);
          } else if (ele.name == "费用累计数") {
            this.monthCarTA = parseInt(ele.value);
          }
        });

        //今日运单量
        this.tbWarehousingGoods = res.data.data.columnarPic
        // this.tbWarehousingGoods.accessData.forEach(ele => {
        //   this.dataTime.push(ele.time)
        // });
        // console.log(this.dataTime,'tbWarehousingGoods')


        // this.handlerRailWayData(res.data.data);
        // this.monthCarTS = parseInt(res.data.data.monthCarTS);

        // this.monthCarTA = parseInt(res.data.data.monthCarTA);
        //车辆进出情况
        if (res.data.data.linePic.inData.length > 0) {
          res.data.data.linePic.inData.forEach((element) => {
            this.tbVehicleAccessList.documentDate.push(element.time);
            this.tbVehicleAccessList.inToday.push(element.count);
          });
          res.data.data.linePic.outData.forEach((ele) => {
            this.tbVehicleAccessList.outToday.push(ele.count);
          });
        } else {
          this.tbVehicleAccessList = {};
        }

        // res.data.data.tbWarehousingGoods.forEach((element) => {
        //   this.tbWarehousingGoods.documentDate.push(element.documentDate);
        //   this.tbWarehousingGoods.warehousingInToday.push(
        //     element.warehousingInToday
        //   );
        //   this.tbWarehousingGoods.warehousingOutToday.push(
        //     element.warehousingOutToday
        //   );
        //   this.tbWarehousingGoods.warehousingBalanceToday.push(
        //     element.warehousingBalanceToday
        //   );
        // });

        // if (res.data.data.tbContainerHandlingVolumeList.length > 0) {
        //   res.data.data.tbContainerHandlingVolumeList.forEach((element) => {
        //     this.tbContainerHandlingVolumeList.documentDate.push(
        //       element.documentDate
        //     );
        //     this.tbContainerHandlingVolumeList.arrived.push(element.arrived);
        //     this.tbContainerHandlingVolumeList.send.push(element.send);
        //   });
        // } else {
        //   this.tbContainerHandlingVolumeList = {};
        // }


        // let { values } = Object;
        res.data.data.onPassages.forEach((v) => {
          this.tbForecastOnWays.push([v.consignee, v.goodsName, v.trainSign, v.railwaySendName, v.destStationName, v.currentStationName]);
        });


        // res.data.data.tbCarDistributions.forEach((v) => {
        //   this.tbCarDistributions.push(values(v).reverse());
        // });

        // this.tbGeneralSituation = res.data.data.tbGeneralSituation;

        // this.isContainerGoods = true;
        this.isCarCount = true;

        this.isNotice = true
        this.isSwiperData = true
      });
    },
    getOldData() {
      axios({
        method: "get",
        // url: 'https://lyscreen.lywly.com.cn:6002/prod-api/home/screen',
        url: 'https://testscreen.lywly.com.cn/prod-api/home/screen'
        //url: "http://diaodu.lywly.com.cn/prod-api/home/screen",
        // url: "http://150.139.212.142:19091/home/screen",
      }).then((res) => {
        if (res.data.data.tbContainerHandlingVolumeList.length > 0) {
          res.data.data.tbContainerHandlingVolumeList.forEach((element) => {
            this.tbContainerHandlingVolumeList.documentDate.push(element.documentDate);
            this.tbContainerHandlingVolumeList.arrived.push(element.arrived);
            this.tbContainerHandlingVolumeList.send.push(element.send);
          });
        } else {
          this.tbContainerHandlingVolumeList = {};
        }

        res.data.data.tbWarehousingGoods.forEach((element) => {
          this.tbWarehousingGoodsL.documentDate.push(element.documentDate);
          this.tbWarehousingGoodsL.warehousingInToday.push(element.warehousingInToday);
          this.tbWarehousingGoodsL.warehousingOutToday.push(element.warehousingOutToday);
          this.tbWarehousingGoodsL.warehousingBalanceToday.push(
              element.warehousingBalanceToday != null ? element.warehousingBalanceToday : 0
          );
        });
        res.data.data.tbContainerYards.forEach((element) => {
          this.tbContainerYards.documentDate.push(element.documentDate);
          this.tbContainerYards.containerInoutTodayWeight.push(element.containerInoutTodayWeight);
          this.tbContainerYards.containerInoutTodayAir.push(element.containerInoutTodayAir);
          this.tbContainerYards.containerBalanceTodayAir.push(
              element.containerBalanceTodayWeight != null ? element.containerBalanceTodayWeight : 0
          );
        });


        this.railWayData.sentCarYesterday = res.data.data.sentCarYesterday
        this.railWayData.unloadCarYesterday = res.data.data.unloadCarYesterday
        this.railWayData.monthCarS = res.data.data.monthCarS
        this.railWayData.monthCarA = res.data.data.monthCarA
        this.railWayData.sentTYesterday = res.data.data.sentTYesterday
        this.railWayData.unloadTonnesYesterday = res.data.data.unloadTonnesYesterday


        res.data.data.tbCarDistributions.forEach((v) => {
          this.tbForecastOnWaysXC.push([v.client_name, v.item_name, v.vehicle_type, v.number, v.vehicleTypeNumberType, v.departure_station]);
        });

        this.isContainerGoods = true

        this.isStorageGoods = true;
        this.isContainerHandler = true;
      });
    }
  },
  mounted() {
    this.handleChange();
  },
  created() {
    setTimeout(() => {
      this.hide = true;
    }, 500);
    setInterval(() => {
      this.hidebottom = !this.hidebottom;
    }, 10000);
    this.getData();
    this.getOldData()
  },
};
</script>
<style scoped>
.container {
  /* position: relative; */
}

.content {
  width: 3576px;
  height: 1355px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 65px auto;
}

.top-container {
  width: 950px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}

.top-container2 {
  width: 1565px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-around;
}

.top-container3 {
  width: 967px;
  height: 1355px;
  display: flex;
  flex-direction: column;
  align-content: space-around;
}

.item {
  width: 950px;
  height: 429px;
  margin-bottom: 12px;
}

.item2 {
  width: 100%;
  height: 30%;
}

.item3 {
  width: 100%;
  height: 128px;
  margin-top: 45px;
}

.item2:nth-child(1) {
  margin-top: 7px;
  margin-bottom: 27 rpx;
}

.boxArea {
  width: 100%;
  height: 661px;
  margin-top: 34px;
}

.bg {
  width: 3939px;
  height: 1675px;
  background-size: cover;
}

.left-content {
  position: absolute;
  width: 24%;
  height: calc(100% - 22px);
  top: 10%;
  left: 7%;
}

.right-content {
  width: 24%;
  position: absolute;
  top: 10%;
  right: 7%;
}

.swiperData {
  width: 100%;
  height: 103%;
}

.inTransit {
  width: 100%;
  height: 420px;
  margin-top: 11px;
}

.animate-left {
  transform: translateX(-1300px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-left-hide {
  transform: translateX(0px);
}

.animate-right {
  transform: translateX(1300px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-right-hide {
  transform: translateX(0px);
}

.animate-top {
  transform: translateY(-1300px);
  opacity: 0;
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-top-hide {
  transform: translateY(0px);
  opacity: 1;
}

.animate-bottom {
  transform: translateY(1000px);
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.animate-bottom-hide {
  transform: translateY(0px) !important;
}
</style>
